
import { getTicketList } from "@/api/couponManage";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import CouponItem from "./components/couponItem.vue";
import { pxToVw } from "@/utils/pxToVw";
import SearchBar from "@/components/SearchBar/index.vue";

@Component({
  name: "CouponManage",
  components: { CouponItem, SearchBar },
})
export default class couponManage extends Vue {
  @Getter companyId!: string;
  @Getter bottomSafetyHeight!: number;

  get bottomSafetyHeightVw(): string {
    return this.bottomSafetyHeight ? pxToVw(this.bottomSafetyHeight) : pxToVw(12);
  }

  couponList = [];
  loading = false;
  finished = false;
  refreshing = false;
  isBatch = false;
  // 2. 新增：存储滚动高度
  listScrollTop = 0;
  params = {
    pageIndex: 1,
    pageSize: 10,
    queryContent: "",
    ticketType: '', // 卡券类型
    statusType: '', // 状态类型
  };
  // 临时存储弹窗选择的筛选条件
  tempParams = {
    ticketType: '', // 卡券类型
    statusType: '', // 状态类型
  };
  searchName = '全部分类'
  showClassify = false;
  totalRecords = 0
  
  classify = [
    {
      title: '优惠券类型',
      propName: 'ticketType',
      options: [
        {
          label: '全部',
          value: ''
        },
        {
          label: '兑换券',
          value: 1
        }
      ]
    },
    {
      title: '优惠券方案状态',
      propName: 'statusType',
      options: [
        {
          label: '全部',
          value: ''
        },
        {
          label: '未开始',
          value: 1
        },
        {
          label: '进行中',
          value: 2
        },
        {
          label: '已结束',
          value: 3
        }
      ]
    }
  ]

  // 拼接searchName
  getSearchName() {
    // 从tempParams读取值（确认时同步到params）
    const typeVal = this.tempParams.ticketType
    const statusVal = this.tempParams.statusType

    // 找到对应的标签文本
    const typeOption = this.classify[0].options.find(opt => opt.value === typeVal)
    const statusOption = this.classify[1].options.find(opt => opt.value === statusVal)
    
    const typeLabel = typeOption?.label || '全部'
    const statusLabel = statusOption?.label || '全部'

    // 拼接显示文本
    if (typeVal === '' && statusVal === '') {
      return this.searchName = '全部分类'
    } else {
      return this.searchName = `${typeLabel} · ${statusLabel}`
    }
  }

  created() {
    // 初始化：同步params到tempParams
    this.tempParams = { ...this.params };
    this.getSearchName();
    this.getTicketList()
  }
  
  handleScroll (event: any) {
    this.listScrollTop = event.target.scrollTop
  }

  // 3. 缓存生命周期：页面激活（从详情页返回）时触发
  activated() {
    document.querySelector('.add-goods-scroll') && document.querySelector('.add-goods-scroll').scrollTo(0, this.listScrollTop)
  }
  onLoad() {
    this.params.pageIndex++;
    this.getTicketList();
  }
  onRefresh() {
    this.params.pageIndex = 1;
    this.refreshing = true;
    this.getTicketList();
  }

  getTicketList() {
    getTicketList({
      storeId: this.companyId,
      ...this.params,
      pageIndex: this.params.pageIndex,
      pageSize: this.params.pageSize,
     })
      .then((res) => {
        if (this.refreshing || this.params.pageIndex === 1) {
          this.couponList = [];
        }
        this.couponList = this.couponList.concat(res.data.records);
        this.totalRecords = res.data.totalRecords
        if (this.params.pageIndex >= res.data.totalPages) {
          this.finished = true;
        } else {
          this.finished = false;
        }
        this.refreshing = false;
      })
      .catch(() => {
        this.finished = true;
      })
      .finally(() => {
        this.loading = false;
      });
  }
  onSearch() {
    console.log(88888, this.params)
    this.showClassify = false;
    // 确认搜索时，将临时变量同步到params
    this.params.ticketType = this.tempParams.ticketType;
    this.params.statusType = this.tempParams.statusType;
    this.getSearchName();
    this.params.pageIndex = 1;
    this.getTicketList();
  }
  popupClose() {
    this.showClassify = false;
    // 取消时不再重置筛选条件
    // this.params.ticketType = 0;
    // this.params.statusType = 0;
  }
  popupOpen() {
    this.showClassify = true;
    // 打开弹窗时，同步当前params到tempParams（保留上一次选择）
    this.tempParams = {
      ticketType: this.params.ticketType,
      statusType: this.params.statusType
    };
  }
  selectOption(value, propName) {
    // 修改临时变量而非直接修改params
    this.tempParams[propName] = value;
  }
}
